import React from 'react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '../../../../../apps/frontend/src/redux/slices/packSlice';

const NoData = ({ onResetAll }) => {
  const dispatch = useDispatch();

  const handleReset = () => {
    // Check and call local reset
    if (onResetAll) {
      onResetAll();
    } else {
    }

    dispatch(resetFilters());
  };

  return (
    <tr>
      <td colSpan="7" className="text-center py-8 px-4">
        <h2 className="text-lg font-semibold text-[var(--q3-neutral-default)] mb-2">No Data</h2>
        <p className="text-sm text-[var(--q3-neutral-light)] mb-4">
          You’ve not attempted any test within the selected category. Try changing the category to a different one.
        </p>
        <button
          onClick={handleReset}
          className="px-4 py-2 text-sm font-medium text-[var(--q3-surface-default)] bg-[var(--q3-danger-normal)] rounded-md  transition-colors"
        >
          Clear Category
        </button>
      </td>
    </tr>
  );
};

export default NoData;
